import type { AvailableExchanges, Timeframe, CandleConditionType, UserTriggerType } from '@bit-box/common';
import {
  AlertFrequencyType,
  ConditionOperatorType,
  IndicatorOrCondition,
  IndicatorSeriesType,
  CandleValueType,
  AutoMode,
  MarginMode,
  NotifierType,
  OrderType,
  InvestMode,
  AverageUnitType,
  CandleComputedType,
  OrderMode,
  SearchInvestMode,
  PositionType,
  EditMode,
  CutType,
  UpDown,
  PositionOrderType,
  TriggerTypeBase,
  TriggerType,
  ForcedExitType,
  OperandSourceType,
} from '@bit-box/common';
import type { MainTabType } from '../../common/enums';
import {
  SignalGridColIds,
  MainTabs,
  OrderGridColIds,
  PositionGridColIds,
  SearchOperatorType,
  MarketTabs,
  SymbolGridColIds,
  StrategyButtons,
  StrategyTabs,
  DropAction,
  TriggerTarget,
} from '../../common/enums';

import { ShapeType } from '@bit-box/chart-tools';

export const ExchangeIdCaption: Partial<Record<(typeof AvailableExchanges)[number], string>> = {
  // aax: 'aax',
  // ascendex: 'ascendex',
  // bequant: 'bequant',
  // bibox: 'bibox',
  // bigone: 'bigone',
  // binance: '바이낸스',
  // binancecoinm: 'binancecoinm',
  // binanceus: 'binanceus',
  binanceusdm: 'Binance future USDT Perpetual',
  // bit2c: 'bit2c',
  // bitbank: 'bitbank',
  // bitbay: 'bitbay',
  // bitbns: 'bitbns',
  // bitcoincom: 'bitcoincom',
  // bitfinex: 'bitfinex',
  // bitfinex2: 'bitfinex2',
  // bitflyer: 'bitflyer',
  // bitforex: 'bitforex',
  // bitget: 'bitget',
  // bithumb: '빗썸',
  // bitmart: 'bitmart',
  // bitmex: 'bitmex',
  // bitopro: 'bitopro',
  // bitpanda: 'bitpanda',
  // bitrue: 'bitrue',
  // bitso: 'bitso',
  // bitstamp: 'bitstamp',
  // bitstamp1: 'bitstamp1',
  // bittrex: 'bittrex',
  // bitvavo: 'bitvavo',
  // bkex: 'bkex',
  // bl3p: 'bl3p',
  // blockchaincom: 'blockchaincom',
  // btcalpha: 'btcalpha',
  // btcbox: 'btcbox',
  // btcmarkets: 'btcmarkets',
  // btctradeua: 'btctradeua',
  // btcturk: 'btcturk',
  // buda: 'buda',
  // bw: 'bw',
  // bybit: 'bybit',
  // bytetrade: 'bytetrade',
  // cdax: 'cdax',
  // cex: 'cex',
  // coinbase: '코인베이스',
  // coinbaseprime: 'coinbaseprime',
  // coinbasepro: 'coinbasepro',
  // coincheck: 'coincheck',
  // coinex: 'coinex',
  // coinfalcon: 'coinfalcon',
  // coinmate: 'coinmate',
  // coinone: '코인원',
  // coinspot: 'coinspot',
  // crex24: 'crex24',
  // cryptocom: 'cryptocom',
  // currencycom: 'currencycom',
  // delta: 'delta',
  // deribit: 'deribit',
  // digifinex: 'digifinex',
  // eqonex: 'eqonex',
  // exmo: 'exmo',
  // flowbtc: 'flowbtc',
  // fmfwio: 'fmfwio',
  // ftx: 'FTX',
  // ftxus: 'ftxus',
  // gateio: 'gateio',
  // gemini: 'gemini',
  // hitbtc: 'hitbtc',
  // hitbtc3: 'hitbtc3',
  // hollaex: 'hollaex',
  // huobi: 'huobi',
  // huobijp: 'huobijp',
  // huobipro: 'huobipro',
  // idex: 'idex',
  // independentreserve: 'independentreserve',
  // indodax: 'indodax',
  // itbit: 'itbit',
  // kraken: 'kraken',
  // kucoin: 'kucoin',
  // kucoinfutures: 'kucoinfutures',
  // kuna: 'kuna',
  // latoken: 'latoken',
  // lbank: 'lbank',
  // liquid: 'liquid',
  // luno: 'luno',
  // lykke: 'lykke',
  // mercado: 'mercado',
  // mexc: 'mexc',
  // ndax: 'ndax',
  // novadax: 'novadax',
  // oceanex: 'oceanex',
  // okcoin: 'okcoin',
  // okex: 'okex',
  // okex5: 'okex5',
  // okx: 'okx',
  // paymium: 'paymium',
  // phemex: 'phemex',
  // poloniex: 'poloniex',
  // probit: 'probit',
  // qtrade: 'qtrade',
  // ripio: 'ripio',
  // stex: 'stex',
  // therock: 'therock',
  // tidebit: 'tidebit',
  // tidex: 'tidex',
  // timex: 'timex',
  // upbit: '업비트',
  // vcc: 'vcc',
  // wavesexchange: 'wavesexchange',
  // wazirx: 'wazirx',
  // whitebit: 'whitebit',
  // woo: 'woo',
  // xena: 'xena',
  // yobit: 'yobit',
  // zaif: 'zaif',
  // zb: 'zb',
  // zipmex: 'zipmex',
  // zonda: 'zonda',
};

// 열거형 상수에 대한 캡션 언어 리소스
// export const codeCaptions: Record<string, Record<string, string>> = {
export const TimeframeCaption: Record<Timeframe, string> = {
  '1m': '1m',
  '3m': '3m',
  '5m': '5m',
  '15m': '15m',
  '30m': '30m',
  '1h': '1h',
  '2h': '2h',
  '4h': '4h',
  '6h': '6h',
  '8h': '8h',
  '12h': '12h',
  '1d': '1D',
  '3d': '3D',
  '1w': '1W',
  '1M': '1M',
};
// export const CompareResultTypeCaption = {
//   [CompareResultType.ABOVE]: '위',
//   [CompareResultType.EQUAL_OR_INSIDE]: '가운데',
//   [CompareResultType.BELOW]: '아래',
// };

//open, high, low, close, (H+L)/2, (H+L+C)/3, (O+H+L+C)/4, (H+L+C+C)/4
export const CandleValueTypeCaption: Record<CandleValueType, string> = {
  [CandleValueType.OPEN]: '시가',
  [CandleValueType.HIGH]: '고가',
  [CandleValueType.LOW]: '저가',
  [CandleValueType.CLOSE]: '최신가',
  [CandleValueType.VOLUME]: '볼륨',
  [CandleValueType.TAKER_BUY_VOLUME]: '시장가 매수 볼륨',
};

export const CandleComputedTypeCaption: Record<CandleComputedType, string> = {
  [CandleComputedType.CLOSE_OPEN_DELTA]: '최신가-시가 차이',
  [CandleComputedType.CLOSE_OPEN_DELTA_ABSOLUTE]: '최신가-시가 차이 절대값',
  [CandleComputedType.CLOSE_OPEN_DELTA_PERCENT]: '최신가-시가 차이 퍼센트',
  [CandleComputedType.CLOSE_OPEN_DELTA_PERCENT_ABSOLUTE]: '최신가-시가 차이 퍼센트 절대값',
  [CandleComputedType.HIGH_LOW_DELTA]: '고가-저가 차이',
  [CandleComputedType.HIGH_LOW_DELTA_PERCENT]: '고가-저가 차이 퍼센트',
  [CandleComputedType.CLOSE_LOW_DELTA]: '최신가-저가 차이',
  [CandleComputedType.CLOSE_LOW_DELTA_PERCENT]: '최신가-저가 차이 퍼센트',
  [CandleComputedType.CLOSE_HIGH_DELTA]: '최신가-고가 차이',
  [CandleComputedType.CLOSE_HIGH_DELTA_PERCENT]: '최신가-고가 차이 퍼센트',
  [CandleComputedType.HL]: '(고가+저가)/2',
  [CandleComputedType.HLC]: '(고가+저가+최신가)/3',
  [CandleComputedType.OHLC]: '(시가+고가+저가+최신가)/4',
  [CandleComputedType.HLCC]: '(고가+저가+최신가+최신가)/4',
};

export const CandleConditionTypeCaption: Record<CandleConditionType, string> = {
  ...CandleValueTypeCaption,
  ...CandleComputedTypeCaption,
};

export const ConditionOperatorTypeCaption: Record<ConditionOperatorType, string> = {
  [ConditionOperatorType.EQUAL]: '같음',
  [ConditionOperatorType.NOT_EQUAL]: '같지 않음',
  [ConditionOperatorType.CROSSING]: '돌파',
  [ConditionOperatorType.CROSSING_UP]: '상향돌파',
  [ConditionOperatorType.CROSSING_DOWN]: '하향돌파',
  [ConditionOperatorType.GREATER_THAN]: '...보다 큼',
  [ConditionOperatorType.EQUAL_OR_GREATER_THAN]: '...보다 크거나 같음',
  [ConditionOperatorType.LESS_THAN]: '...보다 작음',
  [ConditionOperatorType.EQUAL_OR_LESS_THAN]: '...보다 작거나 같음',
  [ConditionOperatorType.CLOSER]: '가까워짐',
  [ConditionOperatorType.EQUAL_OR_CLOSER]: '같거나 가까워짐',
  [ConditionOperatorType.FARTHER]: '멀어짐',
  [ConditionOperatorType.EQUAL_OR_FARTHER]: '같거나 멀어짐',
  [ConditionOperatorType.ENTERING_CHANNEL]: '채널진입',
  [ConditionOperatorType.EXITING_CHANNEL]: '채널탈출',
  [ConditionOperatorType.INSIDE_CHANNEL]: '채널안',
  [ConditionOperatorType.OUTSIDE_CHANNEL]: '채널밖',
  [ConditionOperatorType.WEBHOOK]: '웹훅',
};

export const OperandSourceTypeCaption: Record<OperandSourceType, string> = {
  [OperandSourceType.FORMULA]: '수식',
  [OperandSourceType.OHLCV]: '캔들',
  [OperandSourceType.VALUE]: '값',
  [OperandSourceType.INDICATOR]: '지표',
  [OperandSourceType.SHAPE]: '도형',
  [OperandSourceType.WEBHOOK]: '웹훅',
};

export const AlertFrequencyTypeCaption: Record<AlertFrequencyType, string> = {
  [AlertFrequencyType.REALTIME]: '실시간',
  [AlertFrequencyType.ONLY_ONCE]: '딱 한 번',
  [AlertFrequencyType.ONLY_PER_BAR]: '봉마다 한 번',
  [AlertFrequencyType.ONLY_PER_BAR_CLOSE]: '봉 닫힐 때 한 번',
  [AlertFrequencyType.ONLY_PER_MINUTE]: '분당 한 번',
};

export const IndicatorSeriesTypeCaption: Record<IndicatorSeriesType, string> = {
  [IndicatorSeriesType.AREA]: '영역',
  [IndicatorSeriesType.ALTAREA]: '교차영역',
  [IndicatorSeriesType.LINE]: '선',
  [IndicatorSeriesType.BAR]: '바',
  [IndicatorSeriesType.ALTBAR]: '교차바',
  [IndicatorSeriesType.CANDLE]: '캔들',
  [IndicatorSeriesType.ALTLINE]: '교차선',
};

export const MarginModeCaption: Record<MarginMode, string> = {
  [MarginMode.CROSS]: '크로스',
  [MarginMode.ISOLATED]: '격리',
};

/**
 * 이하는 Interface 캡션
 **/

export const AlertOperandCaption = {
  type: '유형',
  sourceId: '데이터 소스 ID',
  output: '소스',
  value: '값',
  valueOffset: '값 오프셋',
  valueOffsetByPercent: '퍼센트',
  candleOffset: '캔들 오프셋',
  strokeStyle: '선 색',
};

/**
 * todo: 삭제 예정
 */
export const AlertConfigCaption = {
  title: '알림 조건',
  id: 'ID',
  name: '이름',
  type: '종류',
  timeframes: 'Timeframe 선택',
  operator: '조건',
  condition: '조건',
  operands: ['소스', '비교값', '비교값'],
  consecutive: '연속 매칭',
  useConsecutive: '연속 매칭',
  consecutiveCheckTooltip: '이 조건이 연속으로 매칭된 횟수가 특정 범위 내인 경우에만 매칭된 것으로 인정합니다.',
  consecutiveInputTooltip:
    '연속으로 매칭된 횟수가 최소 ~ 최대 사이인 경우에만 알림이 발생합니다. 최소와 최대는 빈 값이거나 0인 경우 무시됩니다.',
  minConsecutive: '최소',
  maxConsecutive: '최대',
  candleOffsetTooltip: `[캔들 오프셋]이 음수이면 과거 캔들(-1이면 직전 캔들)을, 양수이면 미래 캔들(1이면 직후 캔들)을 참조합니다.`,
  useOffsetCheckTooltip: '참조할 소스 또는 비교값의 캔들 위치를 변경하거나 값을 변환하여 비교합니다.',
  useOffsetInputTooltip: `[값 오프셋]은 값을 조정하기 위한 설정입니다. [퍼센트] 모드로 설정하면 소스의 값에 해당 퍼센티지를 적용합니다.\n
  [+/-] 모드를 선택하면 소스의 값에 해당 입력된 값을 더하거나 뺍니다.`,
  frequency: '주기',
  fillStyle: '채널 채움 색',
  expireAt: '만기 시간',
  disabled: '사용 안 함',
  newPanel: '새 패널',
};

export const ConditionFormCaption = {
  title: '조건',
  id: 'ID',
  name: '이름',
  group: '그룹',
  timeframe: '시간 캔들',
  operator: '조건',
  operands: ['기준 항목', '비교 항목', '비교 항목'],
  consecutive: '연속 매칭',
  useConsecutive: '연속 매칭',
  consecutiveCheckTooltip: '이 조건이 연속으로 매칭된 횟수가 특정 범위 내인 경우에만 매칭된 것으로 인정합니다.',
  consecutiveInputTooltip:
    '연속으로 매칭된 횟수가 최소 ~ 최대 사이인 경우에만 알림이 발생합니다. 최소와 최대는 빈 값이거나 0인 경우 무시됩니다.',
  minConsecutive: '최소',
  maxConsecutive: '최대',
  useOffsetCheckTooltip: '참조할 소스 또는 비교값의 캔들 위치를 변경하거나 값을 변환하여 비교합니다.',
  useOffsetInputTooltip: `[캔들 오프셋]이 음수이면 과거 캔들(-1이면 직전 캔들)을, 양수이면 미래 캔들(1이면 직후 캔들)을 참조합니다.\n
  [값 오프셋]은 값에 더하거나 뺄 값을 지정합니다.\n
  [퍼센트] 체크를 켜면 [값 오프셋]을 퍼센티지로 인식하여 현재 값의 지정한 퍼센트를 현재 값에 더하거나 뺀 후 비교할 수 있습니다.`,
  usages: '용도',
  signalName: '신호명',
  disabled: '조건 사용 안 함',
  defaultGroup: '기본 그룹',
  groupTooltip:
    '같은 그룹에 속한 조건들은 AND(그리고) 방식으로 비교하고, 서로 다른 그룹끼리는 OR(또는) 방식으로 비교합니다.',
};

export const IndicatorInputCaption = {
  inReal: '소스',
};
export const IndicatorOutputCaption = {
  value: '값',
  strokeStyle: '선 색',
  strokeDasharray: '선 모양',
  strokeWidth: '선 두께',
  hidden: '숨김',
};

export const IndicatorSeriesCaption = {
  seriesLine: '선',
  seriesFill: '채움',
  seriesShow: '표시',
  seriesUp: '상승',
  seriesDown: '하락',
  seriesPlus: '양수',
  seriesMinus: '음수',
  seriesLine1: '선 1',
  seriesLine2: '선 2',
};

export const IndicatorConfigCaption = {
  title: '지표',
  id: 'ID',
  funcId: '함수 ID', // 참조하는 TaLib 함수 id
  name: '이름',
  inputs: '입력',
  outputs: '출력', // 출력값 이름의 선 색상 또는 스타일 설정
  series: '시리즈',
  newPanel: '새 패널',
  disabled: '비활성',
};

export const NotifierTypeCaption: Record<NotifierType, string> = {
  [NotifierType.TELEGRAM]: '텔레그램',
  [NotifierType.DISCORD]: '디스코드',
};

export const StrategyConfigCaption = {
  name: '이름',
  timeframes: '매매 지표 생성 주기',
};

export const TimeframesConfigCaption = {
  title: '매매 지표 생성 주기',
};

export const ConfigTabkey = {
  exchange: 'exchange-config',
  invest: 'invest-config',
  notifier: 'notifier-config',
  // strategy: 'strategy-config',
  // market: 'market-config',
} as const;

export const ConfigTabCaption = {
  // [ConfigMenukey.exchange]: '거래소 설정',
  // [ConfigMenukey.invest]: '계산 설정',
  // [ConfigMenukey.strategy]: '손절/익절 설정', // '전략 설정',
  // // [ConfigMenukey.market]: '종목 선택',
  // [ConfigMenukey.notifier]: '알림 전송 설정',
  [ConfigTabkey.exchange]: '거래소',
  [ConfigTabkey.invest]: '계산',
  // [ConfigMenukey.strategy']: '동작',
  [ConfigTabkey.notifier]: '알림',
};

// export const InvestModeCaption: Record<InvestMode, string> = {
//   [InvestMode.REAL]: '투자',
//   [InvestMode.SIMULATION]: '가상투자',
// };
export const InvestModeCaption: Record<InvestMode, string> = {
  [InvestMode.REAL]: '투자',
  [InvestMode.SIMULATION]: '모의투자',
  [InvestMode.BACKTEST]: '백테스트',
};

export const SearchInvestModeCaption: Record<SearchInvestMode, string> = {
  [SearchInvestMode.ALL]: '전체',
  [SearchInvestMode.REAL]: InvestModeCaption[InvestMode.REAL],
  [SearchInvestMode.SIMULATION]: InvestModeCaption[InvestMode.SIMULATION],
  [SearchInvestMode.BACKTEST]: InvestModeCaption[InvestMode.BACKTEST],
  [SearchInvestMode.NONE]: '미생성',
};

export const OrderModeCaption: Record<OrderMode, string> = {
  [OrderMode.REAL]: InvestModeCaption[InvestMode.REAL],
  [OrderMode.SIMULATION]: InvestModeCaption[InvestMode.SIMULATION],
  [OrderMode.BACKTEST]: InvestModeCaption[InvestMode.BACKTEST],
  [OrderMode.BACK_SIGNAL]: '백시그널',
};

// export const MainTabCaption: Record<MainTabType, string> = {
//   ...InvestModeCaption,
//   [MainTabs.STRATEGY]: '전략',
// };
export const MainTabCaption: Record<MainTabType, string> = {
  [InvestMode.REAL]: InvestModeCaption[InvestMode.REAL],
  [InvestMode.SIMULATION]: InvestModeCaption[InvestMode.SIMULATION],
  [InvestMode.BACKTEST]: InvestModeCaption[InvestMode.BACKTEST],
  [MainTabs.CREATOR]: '전략수립',
  [MainTabs.STRATEGY]: '전략',
};

export const StrategyTabCaption: Record<StrategyTabs, string> = {
  [StrategyTabs.TRIGGER]: '매매',
  [StrategyTabs.SIGNAL]: '신호',
  [StrategyTabs.INDICATOR]: '지표',
};

export const StrategyButtonCaption: Partial<Record<StrategyButtons, string>> = {
  [StrategyButtons.SIGNAL_ENTER]: '매매',
  [StrategyButtons.SIGNAL]: StrategyTabCaption[StrategyTabs.SIGNAL],
  [StrategyButtons.INDICATOR]: StrategyTabCaption[StrategyTabs.INDICATOR],
  // [StrategyButtons.SIGNAL_EXIT]: '신호 청산',
  // [StrategyButtons.TRAILING_EXIT]: '추적 청산',
  // [StrategyButtons.EXCLUSIVE_EXIT]: '구간 추적 청산',
  // [StrategyButtons.OVERLAPPING_EXIT]: '단계 추적 청산',
};

export const CheckListButtonCaption = {
  checkList: '체크리스트',
};

export const ShapeTypeCaption: Record<ShapeType, string> = {
  [ShapeType.MEASURE]: '측정 도구',

  // Lines
  [ShapeType.TREND_LINE]: '추세선',
  [ShapeType.RAY]: '레이',
  [ShapeType.INFO_LINE]: '정보선',
  [ShapeType.HORZ_LINE]: '수평선',
  [ShapeType.VERT_LINE]: '수직선',
  [ShapeType.PARALLEL_CHANNEL]: '평행 채널',

  // Fibonacci
  [ShapeType.FIB_RETRACEMENT]: '피보나치 되돌림',
  [ShapeType.FIB_CHANNEL]: '피보나치 채널',

  // Gann
  [ShapeType.GANN_BOX]: '간 박스',
  [ShapeType.GANN_FAN]: '간 팬',

  // Patterns
  [ShapeType.ELLIOTT_IMPULSE_12345]: '엘리엇 충격파 12345',
  [ShapeType.ELLIOTT_CORRECTION_ABC]: '엘리엇 조정파 ABC',
  [ShapeType.XABCD_PATTERN]: 'XABCD 패턴',

  // Shapes
  [ShapeType.RECTANGLE]: '사각형',
  [ShapeType.TRIANGLE]: '삼각형',
  [ShapeType.PATH]: '경로',

  // Text
  [ShapeType.TEXT]: '텍스트',

  //volume profile
  [ShapeType.FIXED_RANGE_VOLUME_PROFILE]: '고정 구간 거래량 프로파일',
  [ShapeType.ANCHORED_VOLUME_PROFILE]: '기준점 고정 거래량 프로파일',

  // Order
  [ShapeType.ORDER_LINE]: 'Order Line',
};

/**
 * 도형 출력값 캡션
 * 참고: 피보나치 레벨은 사용자가 도형별로 설정하므로 여기에 포함하지 않음
 * 레벨 값은 동적으로 appearance.*Levels에서 가져와서 표시
 */
export const ShapeOutputCaption = {
  line: '선',
  upper: '상단',
  lower: '하단',
};

export const MarketTabCaption: Record<MarketTabs, string> = {
  [MarketTabs.POSITION]: '포지션',
  // [MarketTabs.ENTRY]: '진입신호',
  [MarketTabs.INVEST]: '투자후보',
  [MarketTabs.SYMBOL]: '종목선택',
};

export const IndicatorOrConditionCaption: Record<IndicatorOrCondition, string> = {
  [IndicatorOrCondition.INDICATOR]: '지표',
  [IndicatorOrCondition.CONDITION]: '조건',
};

export const SymbolGridColCaptions: Record<SymbolGridColIds, string> = {
  [SymbolGridColIds.SELECTED]: '투자',
  [SymbolGridColIds.SHORT_SYMBOL]: '종목',
  [SymbolGridColIds.LEVERAGE]: '레버리지',
  [SymbolGridColIds.PRICE]: '현재가',
  [SymbolGridColIds.QUOTE_VOLUME]: '거래액',
  [SymbolGridColIds.PERCENTAGE]: '등락률',
  [SymbolGridColIds.FROM_HIGH]: '고점대비',
  [SymbolGridColIds.FROM_LOW]: '저점대비',
  [SymbolGridColIds.HIGH_LOW_CHANGE]: '등락폭',
  // [SymbolGridColIds.ENTER_COUNT]: '진입횟수',

  // [SymbolGridColIds.ENTER_COUNT]: '롱숏비',
  // [SymbolGridColIds.ENTER_COUNT]: '펀딩비',
  [SymbolGridColIds.CORRELATION]: '상관계수',
};

export const SignalGridColCaptions: Record<SignalGridColIds, string> = {
  [SignalGridColIds.MATCHED_AT]: '신호생성',
  [SignalGridColIds.ELAPSED_TIME]: '신호경과',
  [SignalGridColIds.SHORT_SYMBOL]: '종목',
  [SignalGridColIds.PRICE]: '현재가',
  [SignalGridColIds.QUOTE_VOLUME]: '거래액',
  [SignalGridColIds.PERCENTAGE]: '등락률',
  [SignalGridColIds.FROM_HIGH]: '고점대비',
  [SignalGridColIds.FROM_LOW]: '저점대비',
  [SignalGridColIds.HIGH_LOW_CHANGE]: '등락폭',
  [SignalGridColIds.CHANGE]: '신호대비 등략율',
  [SignalGridColIds.ENTER_POSITION]: '진입',
};

export const PositionGridColCaptions: Record<PositionGridColIds, string> = {
  [PositionGridColIds.TIMESTAMP]: '진입일시',
  [PositionGridColIds.ELAPSED_TIME]: '진입경과',
  [PositionGridColIds.SHORT_SYMBOL]: '종목',
  [PositionGridColIds.QUOTE_AMOUNT]: '평가액',
  [PositionGridColIds.ENTER_PRICE]: '진입가',
  [PositionGridColIds.PRICE]: '현재가',
  [PositionGridColIds.NET_PNL]: '순익',
  [PositionGridColIds.NET_ROE]: '순익률',
  [PositionGridColIds.EXIT_TRIGGER]: '청산신호',
  [PositionGridColIds.TREND]: '추세',
  [PositionGridColIds.LIQUIDATION_PRICE]: '청산가',
  [PositionGridColIds.EXIT_POSITION]: '수동청산',
};

export const OrderGridColCaptions: Record<OrderGridColIds, string> = {
  [OrderGridColIds.NO]: 'No',
  [OrderGridColIds.SYMBOL]: '종목',
  [OrderGridColIds.QUOTE_AMOUNT]: '씨드',
  [OrderGridColIds.DATETIME]: '시간',
  [OrderGridColIds.POSITION_ORDER_TYPE]: '구분',
  [OrderGridColIds.LEVERAGE]: '레버리지',
  [OrderGridColIds.MARGIN_MODE]: '마진모드',
  [OrderGridColIds.ENTER_COST]: '투자액',
  [OrderGridColIds.PRICE]: '가격',
  [OrderGridColIds.AMOUNT]: '수량',
  [OrderGridColIds.EXIT_COST]: '청산액',
  [OrderGridColIds.PNL]: '수익',
  [OrderGridColIds.TRADE_FEE]: '수수료',
  [OrderGridColIds.NET_PNL]: '거래순익',
};
export const UseStepsCaption = {
  false: '전량',
  true: '분할',
};

export const AverageUnitTypeCaption: Record<AverageUnitType, string> = {
  [AverageUnitType.SECOND]: '초',
  [AverageUnitType.MINUTE]: '분',
};

export const SearchOperatorTypeCaption: Record<SearchOperatorType, string> = {
  [SearchOperatorType.NONE]: '조건식',
  [SearchOperatorType.EQUAL_OR_GREATER_THAN]: '>=',
  [SearchOperatorType.EQUAL_OR_LESS_THAN]: '<=',
  [SearchOperatorType.GREATER_THAN]: '>',
  [SearchOperatorType.LESS_THAN]: '<',
  [SearchOperatorType.INCLUDE]: '포함',
  [SearchOperatorType.EQUAL]: '일치',
};

export const DropActionCaption: Record<DropAction, string> = {
  [DropAction.COPY]: '복사',
  [DropAction.MOVE]: '이동',
  [DropAction.SHARE]: '공유',
};

export const TriggerTargetCaption: Record<TriggerTarget, string> = {
  [TriggerTarget.SESSION]: '합계',
  [TriggerTarget.POSITION]: '종목별',
};

export const EditModeCaption: Record<EditMode, string> = {
  [EditMode.ADD]: '생성',
  [EditMode.EDIT]: '수정',
  [EditMode.DELETE]: '삭제',
};

export const PositionTypeCaption: Record<PositionType, string> = {
  [PositionType.LONG]: '롱',
  [PositionType.SHORT]: '숏',
};

export const CutTypeCaption: Record<CutType, string> = {
  [CutType.TAKE_PROFIT]: '익절',
  [CutType.STOP_LOSS]: '손절',
};

export const UpDownCaption: Record<UpDown, string> = {
  [UpDown.DOWN]: '하락',
  [UpDown.UP]: '상승',
};

export const OrderTypeCaption: Record<OrderType, string> = {
  [OrderType.ENTER]: '진입',
  [OrderType.EXIT]: '청산',
};

export const IsManualCaption = {
  true: '수동',
  false: '자동',
};

export const AutoModeCaption: Record<AutoMode, string> = {
  /** both: 자동 진입 - 자동 청산 */
  [AutoMode.BOTH]: `${IsManualCaption.false} ${OrderTypeCaption[OrderType.ENTER]} - ${IsManualCaption.false} ${OrderTypeCaption[OrderType.EXIT]}`,
  /** open: 자동 진입 - 수동 청산 */
  [AutoMode.ENTER]: `${IsManualCaption.false} ${OrderTypeCaption[OrderType.ENTER]} - ${IsManualCaption.true} ${OrderTypeCaption[OrderType.EXIT]}`,
  /** close: 수동 진입 - 자동 청산 */
  [AutoMode.EXIT]: `${IsManualCaption.true} ${OrderTypeCaption[OrderType.ENTER]} - ${IsManualCaption.false} ${OrderTypeCaption[OrderType.EXIT]}`,
  /** manual: 수동 진입 - 수동 청산 */
  [AutoMode.MANUAL]: `${IsManualCaption.true} ${OrderTypeCaption[OrderType.ENTER]} - ${IsManualCaption.true} ${OrderTypeCaption[OrderType.EXIT]}`,
};

export const PositionOrderTypeCaption: Record<PositionOrderType, string> = {
  [PositionOrderType.LONG_ENTER]: `${PositionTypeCaption[PositionType.LONG]}${OrderTypeCaption[OrderType.ENTER]}`,
  [PositionOrderType.LONG_EXIT]: `${PositionTypeCaption[PositionType.LONG]}${OrderTypeCaption[OrderType.EXIT]}`,
  [PositionOrderType.SHORT_ENTER]: `${PositionTypeCaption[PositionType.SHORT]}${OrderTypeCaption[OrderType.ENTER]}`,
  [PositionOrderType.SHORT_EXIT]: `${PositionTypeCaption[PositionType.SHORT]}${OrderTypeCaption[OrderType.EXIT]}`,
};

export const TriggerTypeBaseCaption: Record<TriggerTypeBase, string> = {
  [TriggerTypeBase.SIGNAL]: '신호',
  [TriggerTypeBase.TRAILING]: '추적',
  [TriggerTypeBase.EXCLUSIVE]: '구간',
  [TriggerTypeBase.OVERLAPPING]: '단계',
  [TriggerTypeBase.FORCED]: '강제',
};

export const UserTriggerTypeCaption: Record<UserTriggerType, string> = {
  [TriggerType.SIGNAL_ENTER]: `${TriggerTypeBaseCaption[TriggerTypeBase.SIGNAL]} ${OrderTypeCaption[OrderType.ENTER]}`,
  [TriggerType.SIGNAL_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.SIGNAL]} ${OrderTypeCaption[OrderType.EXIT]}`,
  [TriggerType.TRAILING_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.TRAILING]} ${OrderTypeCaption[OrderType.EXIT]}`,
  [TriggerType.EXCLUSIVE_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.EXCLUSIVE]} ${OrderTypeCaption[OrderType.EXIT]}`,
  [TriggerType.OVERLAPPING_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.OVERLAPPING]} ${OrderTypeCaption[OrderType.EXIT]}`,
};

export const TriggerTypeCaption: Record<TriggerType, string> = {
  ...UserTriggerTypeCaption,
  [TriggerType.FORCED_EXIT]: `강제 ${OrderTypeCaption[OrderType.EXIT]}`,
};

export const ForceExitTypeCaption: Record<ForcedExitType, string> = {
  [ForcedExitType.DURATION]: '시한',
  [ForcedExitType.PROFIT_GOAL]: '목표 수익 도달',
  [ForcedExitType.LOSS_GOAL]: '손절 도달',
  [ForcedExitType.TERMINATE]: '프로그램 종료',
  [ForcedExitType.STOP]: '투자 중지',
  [ForcedExitType.SUSPEND]: '절전 모드 진입',
  [ForcedExitType.EXPIRED]: '이용권 만료',
  [ForcedExitType.ERROR]: '오류',
  [ForcedExitType.SESSION_TRIGGER]: '매매 트리거',
  [ForcedExitType.LIQUIDATION]: '강제 청산',
};

export const OVERLAPPING_STEP_EXIT = `${TriggerTypeCaption[TriggerType.OVERLAPPING_EXIT]} 스탑`;

/**
 * 모든 enum을 포함하는 통합 객체
 * useLocaleResources()를 통해 접근 가능
 */
export const enums = {
  ExchangeIdCaption,
  TimeframeCaption,
  CandleValueTypeCaption,
  CandleComputedTypeCaption,
  CandleConditionTypeCaption,
  ConditionOperatorTypeCaption,
  OperandSourceTypeCaption,
  AlertFrequencyTypeCaption,
  IndicatorSeriesTypeCaption,
  AutoModeCaption,
  MarginModeCaption,
  AlertOperandCaption,
  AlertConfigCaption,
  ConditionFormCaption,
  IndicatorInputCaption,
  IndicatorOutputCaption,
  IndicatorConfigCaption,
  NotifierTypeCaption,
  StrategyConfigCaption,
  TimeframesConfigCaption,
  ConfigTabkey,
  ConfigTabCaption,
  InvestModeCaption,
  SearchInvestModeCaption,
  OrderModeCaption,
  MainTabCaption,
  StrategyTabCaption,
  StrategyButtonCaption,
  CheckListButtonCaption,
  ShapeTypeCaption,
  ShapeOutputCaption,
  MarketTabCaption,
  IndicatorOrConditionCaption,
  SymbolGridColCaptions,
  SignalGridColCaptions,
  PositionGridColCaptions,
  OrderGridColCaptions,
  UseStepsCaption,
  AverageUnitTypeCaption,
  SearchOperatorTypeCaption,
  DropActionCaption,
  TriggerTargetCaption,
  PositionTypeCaption,
  CutTypeCaption,
  UpDownCaption,
  OrderTypeCaption,
  IsManualCaption,
  PositionOrderTypeCaption,
  EditModeCaption,
  TriggerTypeBaseCaption,
  UserTriggerTypeCaption,
  TriggerTypeCaption,
  ForceExitTypeCaption,
  OVERLAPPING_STEP_EXIT,
} as const;
